<template>
  <v-app>
      <router-view></router-view>
  </v-app>
</template>

<script>
import {mapGetters, mapState} from "vuex";
export default {
    name: 'App',
    computed: {
        ...mapGetters('settings', [
            'getTooltipText'
        ]),
        ...mapState('auth', [
            'user'
        ])
    },
    provide() {
        return {
            tooltipText: (key) => {
                return this.getTooltipText(key);
            },
            householdId: this?.user?.household_id
        }
    },
}
</script>
